(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToController', HospitalizationDischargeToController);

    HospitalizationDischargeToController.$inject = ['$scope', '$state', 'HospitalizationDischargeTo', 'HospitalizationDischargeToSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function HospitalizationDischargeToController ($scope, $state, HospitalizationDischargeTo, HospitalizationDischargeToSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.hospitalizationDischargeTos = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  HospitalizationDischargeTo.query(function(result) {
                  vm.hospitalizationDischargeTos = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.hospitalizationDischargeTos, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            HospitalizationDischargeTo.query(function(result) {
                vm.hospitalizationDischargeTos = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
